import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

// Generyczny upload plików bez UI dropzone: ukryty input (otwierany np. przez <label for>)
// wysyła wybrane pliki przez direct upload do ActiveStorage, a po wgraniu wszystkich wrzuca
// zebrane signed_id do ukrytego formularza i go submituje (turbo). URL docelowy bierze się
// z formularza, więc kontroler nie jest związany z żadnym konkretnym modułem.
// Limity (liczba plików, rozmiar) domyślnie takie jak w intum-dropzone — dla spójności
// z uploadem przez formularze edycji, które korzystają z tego samego mechanizmu.
export default class extends Controller {
  static targets = ["input", "form", "ids"]
  static values = {
    url: String,
    maxFiles: { type: Number, default: 10 },
    maxFileSize: { type: Number, default: 100000000 },
    tooManyMessage: String,
    tooBigMessage: String,
  }

  // start uploadu po wyborze plików w oknie systemowym
  upload() {
    let files = Array.from(this.inputTarget.files)
    if (files.length === 0) return

    // odrzucamy pliki przekraczające limit rozmiaru (jak domyślny intum-dropzone)
    if (files.some(file => file.size > this.maxFileSizeValue)) {
      if (this.tooBigMessageValue) window.alert(this.tooBigMessageValue)
      files = files.filter(file => file.size <= this.maxFileSizeValue)
    }

    // przycinamy do limitu liczby plików (jak domyślny intum-dropzone)
    if (files.length > this.maxFilesValue) {
      if (this.tooManyMessageValue) window.alert(this.tooManyMessageValue)
      files = files.slice(0, this.maxFilesValue)
    }

    if (files.length === 0) {
      this.inputTarget.value = ""
      return
    }

    const signedIds = []
    let pending = files.length

    files.forEach(file => {
      const directUpload = new DirectUpload(file, this.urlValue)
      directUpload.create((error, blob) => {
        pending -= 1
        if (!error) signedIds.push(blob.signed_id)
        if (pending === 0) this.submit(signedIds)
      })
    })
  }

  // po wgraniu wszystkich plików wysyłamy signed_id do backendu
  submit(signedIds) {
    this.inputTarget.value = ""
    if (signedIds.length === 0) return

    this.idsTarget.value = signedIds.join(",")
    this.formTarget.requestSubmit()
  }
}
